export class CapacitorPluginsBase {
  private capacitor = (window as any).Capacitor;
  protected plugins;
  protected platform;
  constructor () {
    this.plugins = this.capacitor && this.capacitor.Plugins;
    this.platform = this.capacitor && this.capacitor.getPlatform();
  }

  async restoreStatusbarLayout () {
    await this.plugins.StatusBar.setOverlaysWebView({ overlay: true });
    await this.plugins.StatusBar.setOverlaysWebView({ overlay: false });
  }
}